import React, { useState } from "react";
import ReactJson from "react-json-view";

import {
  TextField,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  IconButton,
  Button,
  Modal,
} from "@material-ui/core";

import { StyledTableCell, StyledTableRow } from "../modules/modules";
import SendIcon from "@material-ui/icons/Send";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  table: {
    width: "100%",
    height: "600px",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

// 受注情報のヘッダー情報
const columns = [
  { id: "email", minWidth: 170, type: "text" },
  { id: "id", minWidth: 170, type: "text" },
  { id: "customerId", minWidth: 170, type: "text" },
  { id: "scraping", minWidth: 60, type: "number" },
  { id: "trial", minWidth: 60, type: "text" },
  { id: "profile", minWidth: 30, type: "connection" },
  { id: "buyma", minWidth: 30, type: "connection" },
  { id: "shop", minWidth: 30, type: "connection" },
];

// ■■■■■■■■■■■■■■■■■■
// list
// ■■■■■■■■■■■■■■■■■■
export default function UserInfo(props) {
  const classes = useStyles();
  const handleUpdateGraphql = props.handleUpdateGraphql;
  const userInfos = props.userInfos;

  const [open, setOpen] = useState(false);
  const [body, setBody] = useState({});

  const handleOpen = (username, header) => {
    var data = userInfos.find((e) => {
      return e.id === username;
    });
    setOpen(true);
    setBody(data[header]);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.StrictMode>
      <TableContainer className={classes.table}>
        <Table stickyHeader>
          <TableHead>
            <StyledTableRow>
              {columns.map((column) => (
                <StyledTableCell
                  key={column.id}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.id}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {userInfos.map((item) => {
              return (
                <StyledTableRow key={item["id"]}>
                  {columns.map((col) => {
                    if (
                      col.id === "profile" ||
                      col.id === "buyma" ||
                      col.id === "shop"
                    ) {
                      return (
                        <StyledTableCell
                          key={col.id}
                          style={{ minWidth: col.minWidth }}
                        >
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => handleOpen(item["id"], col.id)}
                          >
                            表示
                          </Button>
                        </StyledTableCell>
                      );
                    } else {
                      return (
                        <StyledTableCell
                          key={col.id}
                          style={{ minWidth: col.minWidth }}
                        >
                          <form
                            onSubmit={(values) => {
                              handleUpdateGraphql("updateUserInfo", values);
                            }}
                          >
                            <TextField
                              name={item["id"]}
                              type={col["type"]}
                              label={col["id"]}
                              defaultValue={item[col["id"]]}
                            />
                            <IconButton color="secondary" type="submit">
                              <SendIcon />
                            </IconButton>
                          </form>
                        </StyledTableCell>
                      );
                    }
                  })}
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal open={open} className={classes.modal} onClose={handleClose}>
        <ReactJson
          src={body}
          theme="twilight"
          enableClipboard={false}
          displayObjectSize={false}
          displayDataTypes={false}
          collapseStringsAfterLength={100}
        />
      </Modal>
    </React.StrictMode>
  );
}
